import { render, staticRenderFns } from "./WhitelistManagement.vue?vue&type=template&id=5c06e8fc&scoped=true"
import script from "./WhitelistManagement.vue?vue&type=script&lang=js"
export * from "./WhitelistManagement.vue?vue&type=script&lang=js"
import style0 from "./WhitelistManagement.vue?vue&type=style&index=0&id=5c06e8fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06e8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c06e8fc')) {
      api.createRecord('5c06e8fc', component.options)
    } else {
      api.reload('5c06e8fc', component.options)
    }
    module.hot.accept("./WhitelistManagement.vue?vue&type=template&id=5c06e8fc&scoped=true", function () {
      api.rerender('5c06e8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/invoiceManage/WhitelistManagement.vue"
export default component.exports